<template>
  <b-modal id="mediaModal" ref="mediaModal" size="md" hide-footer lazy modal-class="media-modal p-0">
    <div slot="modal-header" class="d-flex w-100 justify-content-between">
      <h3 class="modal-title">{{ title }}</h3>
      <button @click="hide()" class="btn close-modal align-self-center">&times;</button>
    </div>
    <audio :src="src" v-if="isAudio" preload="auto" autoplay controls="controls"></audio>

    <video :src="src" v-if="isVideo" type="video/mp4" preload="auto" autoplay controls="controls"></video>
  </b-modal>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'MediaModal',
  methods: {
    hide() {
      this.$refs.mediaModal.hide();
    },
  },
  computed: {
    ...mapState('artworks', ['media']),
    title() {
      return this.media.text;
    },
    type() {
      return this.media.rel;
    },
    isAudio() {
      return this.type === 'audio';
    },
    isVideo() {
      return this.type === 'video';
    },
    src() {
      return this.media.href;
    },
  },
};
</script>
